import { Container } from '@angular/compiler/src/i18n/i18n_ast';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { faHistory, faInfoCircle, faRedoAlt, faSearch, faTrash } from '@fortawesome/free-solid-svg-icons';
import { ContainersService } from '@services/containers/containers.service';
import { ConvertDateService } from '@services/convert-date/convert-date.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { OpendialogDeleteContainerComponent } from './opendialog-delete-container/opendialog-delete-container.component';
import { OpendialogInfosContainerComponent } from './opendialog-infos-container/opendialog-infos-container.component';

@Component({
  selector: 'app-containers',
  templateUrl: './containers.component.html',
  styleUrls: ['./containers.component.scss']
})
export class ContainersComponent extends SubscriptionBaseComponent implements OnInit {

  faHistory = faHistory;
  faInfoCircle = faInfoCircle;
  faTrash = faTrash;
  faSearch = faSearch;
  faRedoAlt = faRedoAlt;

  progressContainer = 66;
  showValue = false;

  displayedColumns: string[] = ['createdOn', 'weight', 'supp'];
  dataSource: MatTableDataSource<Container>;
  containersList: Container[];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  paginationRecords: Pagination;
  pageNo = 0;

  containersFilterForm: FormGroup;
  filterValueContainers = null;
  sortValueRecords: string;

  today = new Date();

  constructor(
    private containersService: ContainersService,
    public router: Router,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private convertDateService: ConvertDateService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
    this.initForm();
    // this.initProgressContainer();
  }

  onSubmit(): void {

    this.filterValueContainers = {
      startedOnFrom: null,
      startedOnTo: null,
      createdOnFrom: null,
      createdOnTo: null,
    };

    const startedOnFrom = this.containersFilterForm.get('startedOnFrom').value;
    const startedOnTo = this.containersFilterForm.get('startedOnTo').value;
    const createdOnFrom = this.containersFilterForm.get('createdOnFrom').value;
    const createdOnTo = this.containersFilterForm.get('createdOnTo').value;


    if (startedOnFrom) {
      this.filterValueContainers.startedOnFrom = this.convertDateService.convertDate(startedOnFrom);
    }
    if (startedOnTo) {
      this.filterValueContainers.startedOnTo = this.convertDateService.convertDate(startedOnTo, true);
    }
    if (createdOnFrom) {
      this.filterValueContainers.createdOnFrom = this.convertDateService.convertDate(createdOnFrom);
    }
    if (createdOnTo) {
      this.filterValueContainers.createdOnTo = this.convertDateService.convertDate(createdOnTo, true);
    }

    this.getRecordsWithFilterReturnFirstPage();
  }

  onPageRecordsChanged(pageEvent: PageEvent): void {

    this.paginationRecords.pageNumber = pageEvent.pageIndex + 1;
    this.getRecordsWithFilter();
  }

  openDialogDeleteContainer(id: string): void {

    const dialogRef = this.dialog.open(OpendialogDeleteContainerComponent, {
      data: { idContainer: id }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.initSub();
      this.router.navigate(['/clicotte']);
    });

  }
  openDialogInfosCOntainer(id: string): void {

    const dialogRef = this.dialog.open(OpendialogInfosContainerComponent, {
      data: { idContainer: id }
    });
  }

  resetFilter(): void {
    this.filterValueContainers = null;
    this.initForm();
    this.getRecordsWithFilterReturnFirstPage();
  }

  private getRecordsWithFilterReturnFirstPage(): void {

    const newRequest = new PaginationRequest(
      this.filterValueContainers,
      this.sortValueRecords,
      1,
    );
    this.containersService.getContainers(newRequest);
  }

  private getRecordsWithFilter(): void {
    const newRequest = new PaginationRequest(
      this.filterValueContainers,
      this.sortValueRecords,
      this.paginationRecords.pageNumber,
    );

    this.containersService.getContainers(newRequest);
  }

  private initSub(): void {
    this.containersService.getContainers(new PaginationRequest());
    this.subscription
      .add(
        this.containersService.eventsListSubject.subscribe(events => {
          this.containersList = events?.body;
          this.paginationRecords = events?.pagination;
          this.initContainerTable();
        })
      );
  }

  private initForm(): void {
    const dateto = new Date();
    const dateFrom = new Date();
    dateFrom.setDate(dateFrom.getDate() - 7);

    this.containersFilterForm = this.formBuilder.group({
      startedOnTo: [''],
      startedOnFrom: [''],
      createdOnTo: [''],
      createdOnFrom: [''],
    });
  }

  private initContainerTable(): void {
    this.dataSource = new MatTableDataSource(this.containersList);
    this.dataSource.sort = this.sort;
  }

}
